module.exports = __webpack_public_path__ + "img/safari.dd233d8b.png";